<template>
  <section>
    <v-dialog
      v-if="isActive"
      :value="isActive"
      @click:outside="closeDialog()"
      max-width="600"
      scrollable
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <v-card :loading="isLoading">
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Enviar Mensaje
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 370px">
              <v-row>
                <!-- Tipo de Mensaje -->
                <v-col cols="12" class="pb-0">
                  <ValidationProvider
                    name="Tipo"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-radio-group
                      v-model="typeSelected"
                      :error-messages="errors"
                      class="ml-3"
                      row
                    >
                      <v-radio label="SMS" :value="1"></v-radio>
                      <v-radio label="WhatsApp" :value="2"></v-radio>
                    </v-radio-group>
                  </ValidationProvider>
                </v-col>
                <!-- Gateway -->
                <v-col cols="12" class="pb-0">
                  <ValidationProvider
                    name="Gateway"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      v-model="gatewaySelected"
                      :error-messages="errors"
                      :items="filteredGatewayList"
                      item-text="name"
                      item-value="id"
                      label="Gateway"
                      prepend-inner-icon="mdi-call-made"
                      no-data-text="No hay gateways para mostrar"
                      rounded
                      filled
                      :disabled="typeSelected === null"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <!-- Numero -->
                <v-col cols="12" class="py-0">
                  <ValidationProvider
                    name="Numero"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="payload.to"
                      :error-messages="errors"
                      label="Numero de telefono"
                      prepend-inner-icon="mdi-phone"
                      rounded
                      filled
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <!-- Mensaje -->
                <v-col cols="12" class="py-0">
                  <ValidationProvider
                    name="Mensaje"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      v-model="payload.text"
                      :error-messages="errors"
                      label="Mensaje"
                      prepend-inner-icon="mdi-text-long"
                      rounded
                      counter
                      filled
                    >
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </vuescroll>
          <v-card-actions>
            <v-btn
              @click="closeDialog()"
              class="px-8"
              color="error"
              rounded
              large
              text
            >
              Cerrar
            </v-btn>
            <v-spacer></v-spacer>

            <v-btn
              @click="handleSubmit(() => (isOpenConfirm = true))"
              :disabled="isLoading"
              class="px-8"
              color="success"
              rounded
              large
            >
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
    <!-- Confirm Dialog  -->
    <v-dialog v-model="isOpenConfirm" width="500">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Confimar enviar SMS
            </v-card-title>
          </v-img>
        </v-card-title>

        <v-card-text>
          Esta seguro que desea enviar este mensaje?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            @click="isOpenConfirm = false"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="submitForm"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
export default {
  name: "SmsSend",
  props: {
    isActive: {
      type: Boolean,
    },
  },
  components: { vuescroll },

  data() {
    return {
      payload: {
        to: "",
        text: "",
      },
      gatewaySelected: null,
      typeSelected: null,
      requestPath: "/message_local/",
      gatewayList: [],
      filteredGatewayList: [],
      isOpenConfirm: false,
      isLoading: false,
    };
  },
  created() {
    this.getGateways();
  },
  watch: {
    gatewaySelected(val) {
      if (this.gatewayList.find((el) => el.id === val)?.local === 1)
        this.requestPath = `/message_local/${val}`;
      else if (this.gatewayList.find((el) => el.id === val)?.whatsapp === 1)
        this.requestPath = `/whatsapp_send_post/${val}`;
      else this.requestPath = `/message_gateway/${val}`;
    },
    typeSelected(val) {
      if (val === 2) {
        this.filteredGatewayList = this.gatewayList.filter(
          (item) => item.whatsapp == 1
        );
      } else {
        this.filteredGatewayList = this.gatewayList.filter(
          (item) => item.whatsapp == 0
        );
      }
    },
  },

  methods: {
    async submitForm() {
      this.isLoading = true;
      this.isOpenConfirm = false;
      try {
        await PbxHttpClient.post(this.requestPath, this.payload);
        this.closeDialog();
        this.$snotify.success("Mensaje enviado correctamente", "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo enviar el mesaje", "¡Error!");
      }

      this.isLoading = false;
    },

    async getGateways() {
      const page = 1;
      const itemPerPage = 100;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get("/gateway", {
          params: { page, itemPerPage },
        });
        this.gatewayList = data.data;
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
    },

    closeDialog() {
      this.$emit("close:dialog");
    },
  },
};
</script>

<style></style>
